import React from "react"
import ReactDOM from "react-dom"
import Chart from "./Chart"


class Map extends React.Component {
  constructor() {
    super()
    this.drawCharts = this.drawCharts.bind(this)
    this.scrollUp = this.scrollUp.bind(this)
  }

  scrollUp() {
    window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' })
  }

  coaId = (location) =>
    `coa-${location.toLowerCase()}`

  arrowId = (location) =>
    `arrow-${location.toLowerCase()}`

  chartId = (location) =>
    `chart-${location.toLowerCase()}`

  chartWrapper = (id) =>
    `<div class="chart link" id="${id}"></div>`

  createMap() {
    const map = L.map('project-map', {
      // zoomControl: false,
      // scrollWheelZoom: false,
      dragging: false,
      tap: false,
      minZoom: 8,
      maxZoom: 8
    })
    // map.setView([49.963, 18.23], 8.0)
    map.setView([50.06, 18.23], 8.0)

    return map
  }

  createMarkers() {
    const markers = []
    for (let chart of this.props.charts) {
      markers.push(L.circleMarker(this.markerCoordinates(chart.forecast_location), {
        radius: 5,
        color: 'hsl(180, 100%, 40%)',
        fill: true,
        fillOpacity: '80%'
      }))
    }
    return markers
  }

  createTileLayer() {
    const layer = L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
    })
    return layer

    // const layer = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
    //   attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
    //   minZoom: 1,
    //   maxZoom: 19
    // })
    // return layer

    // const styleId = this.props.styleId
    // const layer = L.tileLayer('https://api.mapbox.com/styles/v1/' + styleId + '/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicHJ6cHJ6IiwiYSI6ImNrNTRoM2hxejAwMmszZ28zYWY2Z2tmajQifQ.ePAKWgPBz8Kasr-EXDUOEw', {
    //   maxZoom: 18,
    //   attribution: 'Map data &copy <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
    //     '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
    //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    //   id: 'mapbox/minimo'
    // })
    // return layer
  }

  createPopup(chart) {
    const popup = L.popup({
      class: 'map-popup',
      autoClose: false,
      closeButton: false,
      closeOnEscapeKey: false,
      closeOnClick: false
    })
    popup.setLatLng(this.chartCoordinates(chart.forecast_location))

    return popup
  }

  chartCoordinates(location) {
    // to west: negative y
    // to north: positive x
    const offset = {
      'Opava': [-0.05, -1.44],
      "Opole": [-0.05, -1.44],
      'Ostrava': [-0.75, -1.44],
      "Rybnik": [-0.05, 1.44],
      "Zilina": [-0.05, 1.44],
    }
    const [x, y] = offset[location]
    const coordinates = this.markerCoordinates(location)

    return [coordinates[0] + x, coordinates[1] + y]
  }

  markerCoordinates(location) {
    const coordinates = {
      'Opava': [49.938848, 17.902382],
      "Opole": [50.666437, 17.92379],
      'Ostrava': [49.829623, 18.285],
      'Rybnik': [50.094596, 18.542079],
      'Zilina': [49.223539, 18.738524]
    }
    return coordinates[location]
  }

  // addCoatOfArmsRybnik() {
  //   const icon = L.icon({
  //     iconUrl: 'images/POL_Rybnik_COA.png',
  //     iconSize: [77 * 0.86, 77],
  //     iconAnchor: [40, 80]
  //   })
  //   return L.marker([50.094596, 18.542079], { icon: icon })
  // }

  createInfoPane() {
    const pane = L.control()
    const translations = this.props.translations
    pane.onAdd = () => {
      return this.createMapKey(translations)
    }
    return pane
  }

  createForecastInfoPane() {
    const pane = L.control({ position: 'bottomleft' })
    const text = this.props.forecastInfo
    pane.onAdd = () => {
      return this.addForecastInfoText(text)
    }
    return pane
  }

  createMapKey(translations) {
    this._div = L.DomUtil.create('div', 'info')
    this._div.innerHTML = `<a class="no-decor" href="/${translations.locale}/caqi"><h3>${translations.caqi_index}</h3> 
        <table class="table map-key">
          <tbody>
          <tr>
            <td class="caqi-class very-high">${translations.very_high}</td>
          </tr>
          <tr>
            <td class="caqi-class high">${translations.high}</td>
          </tr>
          <tr>
            <td class="caqi-class medium darker">${translations.moderate}</td>
          </tr>
          <tr>
            <td class="caqi-class low darker">${translations.low}</td>
          </tr>
          <tr>
            <td class="caqi-class very-low darker">${translations.very_low}</td>
          </tr>
          </tbody>
        </table>
        </a>
      `.trim()
    return this._div
  }

  addForecastInfoText(text) {
    this._div = L.DomUtil.create('div', 'forecast-info')
    this._div.innerHTML = `<h5>${text}</h5>`.trim()
    return this._div
  }

  drawCharts() {
    for (let chart of this.props.charts) {
      const popup = this.createPopup(chart)
      const chartId = this.chartId(chart.forecast_location)
      popup.setContent(this.chartWrapper(chartId))
      popup.openOn(this.map)

      this.drawChart(chart)
    }
  }

  drawChart(chart) {
    const canvas = document.getElementById(this.chartId(chart.forecast_location))

    ReactDOM.render(
      <Chart translations={chart.translations}
             title={chart.title}
             forecast_location={chart.forecast_location}
             labels={chart.labels}
             caqi_pm10={chart.caqi_pm10}
             caqi_pm25={chart.caqi_pm25}
             pm10={chart.pm10}
             pm25={chart.pm25}
             colors={chart.colors}
             date={chart.date}
             onMap={true} />,
      canvas
    )

    const chartWrapper = canvas.parentNode
    // const chartWrapper = canvas
    const arr = document.createElement('div')
    arr.setAttribute('id', this.arrowId(chart.forecast_location))
    arr.setAttribute('class', 'arrow')
    chartWrapper.insertAdjacentElement("afterend", arr)
    // chartWrapper.appendChild(arr)

    const coa = document.createElement('div')
    coa.setAttribute('id', this.coaId(chart.forecast_location))
    coa.setAttribute('class', 'coa')

    const coaText = document.createElement('h3')
    const text = document.createTextNode(`${chart.forecast_location}`)
    coaText.appendChild(text)

    const coaWrapper = document.createElement('div')
    coaWrapper.setAttribute('class', `coa-wrapper ${chart.forecast_location}`)
    coaWrapper.appendChild(coaText)
    coaWrapper.appendChild(coa)

    chartWrapper.insertAdjacentElement("afterend", coaWrapper)
    // chartWrapper.appendChild(coaWrapper)
  }

  componentDidMount() {
    const map = this.createMap()
    this.map = map

    const tileLayer = this.createTileLayer()
    const markers = this.createMarkers()
    const info = this.createInfoPane()
    const info2 = this.createForecastInfoPane()

    markers.forEach(marker => marker.addTo(map))
    tileLayer.addTo(map)
    info.addTo(map, this.props.translations)
    info2.addTo(map)

    // const coatOfArms = this.addCoatOfArmsRybnik()
    // coatOfArms.addTo(map)

    const borders = this.createTritiaBorders()
    borders.forEach(element => element.addTo(map))

    window.addEventListener('load', this.drawCharts)
    window.addEventListener('load', this.scrollUp)

    let that = this;
    $(window).on("resize", function () {
      let height = $(window).height();
      let width = $(window).width();

      let newHeight = height - 70;
      let newWidth = width - 10;
      $("#project-map")
        .height(newHeight)
        .width(newWidth)

      map.invalidateSize()
      that.updateCentre(map, newHeight, newWidth);
    }).trigger("resize")

  }

  updateCentre(map, height, width) {
    if (height < 800 && width < 1025) {
      map.setView([50.06, 18.23], 8.0)
      return
    }
    if (height < 800) {
      map.setView([50.25, 18.23], 8.0)
    }
  }

  createTritiaBorders() {
    const tritia = [[49.39621, 18.40368], [49.40530, 18.36677], [49.42124, 18.37358], [49.44608, 18.35045], [49.46420, 18.30790], [49.48932, 18.30168], [49.49239, 18.26865], [49.48180, 18.25457], [49.48885, 18.20278], [49.51216, 18.17145], [49.50881, 18.13653], [49.52001, 18.12651], [49.51785, 18.08391], [49.50496, 17.99366], [49.52086, 17.99429], [49.53733, 17.97403], [49.54068, 17.91826], [49.56755, 17.88345], [49.54642, 17.85961], [49.56441, 17.84414], [49.58411, 17.85247], [49.60565, 17.83890], [49.62218, 17.81425], [49.63225, 17.77909], [49.67043, 17.75282], [49.66471, 17.73264], [49.67618, 17.69023], [49.70357, 17.68258], [49.72153, 17.69585], [49.75532, 17.67690], [49.76042, 17.65677], [49.74865, 17.61124], [49.75758, 17.56248], [49.77111, 17.52766], [49.83082, 17.48199], [49.85261, 17.48750], [49.85506, 17.45649], [49.82392, 17.40714], [49.79230, 17.38641], [49.81135, 17.35820], [49.84840, 17.38033], [49.86349, 17.35626], [49.85649, 17.32026], [49.83492, 17.26506], [49.81925, 17.25529], [49.82785, 17.20959], [49.85166, 17.21669], [49.84916, 17.17828], [49.87966, 17.14668], [49.90966, 17.17559], [49.91997, 17.16229], [49.93527, 17.19159], [49.95907, 17.19889], [49.98757, 17.17159], [50.01298, 17.17169], [50.04678, 17.22090], [50.06578, 17.23621], [50.10128, 17.22311], [50.11529, 17.24821], [50.14179, 17.24301], [50.14699, 17.26071], [50.17169, 17.28482], [50.18709, 17.31172], [50.18389, 17.34113], [50.22129, 17.37913], [50.20869, 17.40093], [50.21359, 17.42354], [50.26306, 17.43119], [50.28275, 17.38906], [50.28107, 17.34259], [50.30804, 17.35368], [50.32710, 17.32780], [50.31750, 17.28993], [50.33208, 17.24733], [50.36402, 17.20114], [50.38613, 17.20376], [50.38042, 17.14333], [50.40496, 17.11075], [50.40696, 17.05253], [50.42775, 16.99829], [50.42008, 16.98338], [50.44050, 16.92194], [50.48068, 16.94786], [50.47561, 16.97600], [50.48032, 17.02009], [50.46327, 17.04156], [50.47562, 17.06196], [50.50487, 17.05669], [50.51416, 17.06951], [50.53695, 17.06131], [50.58745, 17.11492], [50.60750, 17.12187], [50.61634, 17.18640], [50.61322, 17.23597], [50.64069, 17.23022], [50.66122, 17.23890], [50.71370, 17.22079], [50.71773, 17.25212], [50.74460, 17.27555], [50.75334, 17.29758], [50.77459, 17.25622], [50.79234, 17.28490], [50.78446, 17.34475], [50.79427, 17.35460], [50.82268, 17.32625], [50.83177, 17.34280], [50.85060, 17.32820], [50.86207, 17.38429], [50.88822, 17.39426], [50.90065, 17.35243], [50.92461, 17.38195], [50.91073, 17.40746], [50.91620, 17.43246], [50.93711, 17.43956], [50.96709, 17.43140], [50.97559, 17.50155], [50.99207, 17.54071], [51.01163, 17.51428], [51.04296, 17.53353], [51.06516, 17.52432], [51.06783, 17.55821], [51.08184, 17.58213], [51.09260, 17.56243], [51.11083, 17.57822], [51.12942, 17.57638], [51.15449, 17.54475], [51.17543, 17.62061], [51.16085, 17.66926], [51.18679, 17.75382], [51.19415, 17.79527], [51.19137, 17.83684], [51.17244, 17.85118], [51.12225, 17.81913], [51.11509, 17.86126], [51.10379, 17.88524], [51.10887, 17.93946], [51.13104, 18.03935], [51.16618, 18.07816], [51.15586, 18.10843], [51.16855, 18.12433], [51.17471, 18.16153], [51.15798, 18.18479], [51.15596, 18.26497], [51.13534, 18.30524], [51.13749, 18.36729], [51.10437, 18.46975], [51.10423, 18.51541], [51.13274, 18.51547], [51.13902, 18.55337], [51.08203, 18.57761], [51.07712, 18.62356], [51.05463, 18.66081], [51.06588, 18.71569], [51.06232, 18.74941], [51.07269, 18.86301], [51.05898, 18.88353], [51.09822, 18.91917], [51.09015, 18.95562], [51.06651, 19.01163], [51.05137, 19.01787], [51.02621, 19.10449], [50.99960, 19.12356], [51.00958, 19.14980], [50.99452, 19.16496], [50.98552, 19.20647], [50.99039, 19.24073], [51.00625, 19.25616], [51.02358, 19.24315], [51.04548, 19.29177], [51.04619, 19.32269], [51.01315, 19.32925], [51.00125, 19.38925], [50.96490, 19.43229], [50.94390, 19.43802], [50.92587, 19.46335], [50.88588, 19.47112], [50.88107, 19.50918], [50.89413, 19.52508], [50.90832, 19.56955], [50.90528, 19.58671], [50.87731, 19.61394], [50.87438, 19.66157], [50.85454, 19.66139], [50.84522, 19.68293], [50.84328, 19.72790], [50.86597, 19.74706], [50.83852, 19.81944], [50.80295, 19.81300], [50.81782, 19.78416], [50.77732, 19.77051], [50.75468, 19.74173], [50.75239, 19.70430], [50.73305, 19.71947], [50.71597, 19.75511], [50.72541, 19.81077], [50.70591, 19.80827], [50.70573, 19.84334], [50.68296, 19.87303], [50.65139, 19.83521], [50.64701, 19.87568], [50.62992, 19.90896], [50.61586, 19.89841], [50.62169, 19.86192], [50.59075, 19.84090], [50.55451, 19.78872], [50.55510, 19.84170], [50.54385, 19.85476], [50.53973, 19.90122], [50.51141, 19.91226], [50.48872, 19.96398], [50.47352, 19.90056], [50.45223, 19.89674], [50.44780, 19.85524], [50.43513, 19.85349], [50.43455, 19.81538], [50.44489, 19.76772], [50.44088, 19.72478], [50.44816, 19.70186], [50.41599, 19.66704], [50.40585, 19.61620], [50.41674, 19.51859], [50.39698, 19.48756], [50.36598, 19.49169], [50.32398, 19.48378], [50.32295, 19.41472], [50.30258, 19.41060], [50.27846, 19.38688], [50.24962, 19.34013], [50.22554, 19.42872], [50.20621, 19.41241], [50.19242, 19.37344], [50.17702, 19.35176], [50.15393, 19.35382], [50.14415, 19.33164], [50.14354, 19.27048], [50.11973, 19.27782], [50.11084, 19.23922], [50.07465, 19.21248], [50.06043, 19.16903], [50.03354, 19.13616], [50.00924, 19.11902], [49.97177, 19.11283], [49.93885, 19.11884], [49.93951, 19.16165], [49.94989, 19.18458], [49.88596, 19.19424], [49.86634, 19.15722], [49.85303, 19.17094], [49.87158, 19.20261], [49.86066, 19.27086], [49.85051, 19.28923], [49.81641, 19.28657], [49.77789, 19.31678], [49.77776, 19.36604], [49.76168, 19.40000], [49.77217, 19.42018], [49.73493, 19.44465], [49.72023, 19.42972], [49.69476, 19.37919], [49.67733, 19.39177], [49.67643, 19.45944], [49.66081, 19.47778], [49.64801, 19.46892], [49.62438, 19.48076], [49.61377, 19.46739], [49.58704, 19.48025], [49.57397, 19.53009], [49.53683, 19.52969], [49.47166, 19.56680], [49.44751, 19.61253], [49.45771, 19.64004], [49.43092, 19.64243], [49.41063, 19.63067], [49.40353, 19.68476], [49.39113, 19.72780], [49.40640, 19.74116], [49.40964, 19.79101], [49.37207, 19.80135], [49.34926, 19.79551], [49.32241, 19.80491], [49.30214, 19.79257], [49.27729, 19.82274], [49.26964, 19.79368], [49.23835, 19.77300], [49.20800, 19.76343], [49.20635, 19.80521], [49.19431, 19.84097], [49.20437, 19.88039], [49.20029, 19.90048], [49.14069, 19.93968], [49.10940, 19.95232], [49.10508, 20.01316], [49.10866, 20.03789], [49.06788, 20.01965], [49.04878, 20.02505], [49.01652, 20.01136], [48.99766, 19.99072], [48.91720, 20.04259], [48.90980, 20.01787], [48.91590, 19.97320], [48.90668, 19.93691], [48.91075, 19.90375], [48.90822, 19.82237], [48.91729, 19.81962], [48.90624, 19.76382], [48.91727, 19.67476], [48.93456, 19.64898], [48.94416, 19.59055], [48.94763, 19.53835], [48.92735, 19.43733], [48.92326, 19.37985], [48.89979, 19.35042], [48.89342, 19.32871], [48.86632, 19.31446], [48.85859, 19.26461], [48.87929, 19.27014], [48.89363, 19.24638], [48.87605, 19.08426], [48.88531, 19.04598], [48.87603, 19.01998], [48.85746, 19.01997], [48.85175, 18.99724], [48.81889, 19.00265], [48.80389, 18.99076], [48.79032, 19.01670], [48.74961, 18.99725], [48.74316, 18.92273], [48.75384, 18.89031], [48.76955, 18.88163], [48.74591, 18.82552], [48.76732, 18.81356], [48.79510, 18.77454], [48.82791, 18.75059], [48.84850, 18.69746], [48.89781, 18.70908], [48.91062, 18.69166], [48.93926, 18.71968], [48.95991, 18.69245], [48.95629, 18.67620], [48.96472, 18.62841], [48.96102, 18.59048], [48.97313, 18.58278], [48.93718, 18.52128], [48.93916, 18.48223], [48.95264, 18.46366], [48.96566, 18.49932], [48.98427, 18.50781], [48.99880, 18.56954], [49.02390, 18.59974], [49.06320, 18.60268], [49.09664, 18.56652], [49.11387, 18.59248], [49.12309, 18.57282], [49.14237, 18.57374], [49.15516, 18.55403], [49.18695, 18.47203], [49.21181, 18.44342], [49.25526, 18.43138], [49.27182, 18.40936], [49.31895, 18.37420], [49.34252, 18.38574], [49.36797, 18.41641], [49.39621, 18.40368]]

    return [
      L.polygon(tritia, { color: 'green' }),
    ]
  }

  render() {
    return (<React.Fragment></React.Fragment>)
  }
}

export default Map
